<style scoped lang="scss">

</style>

<template>
    <div class="uk-container project-step" v-if="confirmation">
        <ValidationObserver
                v-slot="{ handleSubmit, invalid, dirty }"
                ref="financialForm"
        >
            <form class="uk-form" @submit.prevent="handleSubmit(create)" autocomplete="chrome-off" >

                <div class="uk-grid" >
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <h2>Property Information</h2>
                    </div>
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p class=""><small>&nbsp;Property Name Your Tenants Will Recognize in a Search</small></p>
                        <div class="uk-grid">
                            <div class="uk-width-4-5">
                                <validated-section :errors="errors" field="project_name">
                                    <autocomplete
                                            :placeholder="'Property Name'"
                                            ref="propertyAutocomplete"
                                            class="form-autocomplete"
                                            :search="search"
                                            :get-result-value="getProjectValue"
                                            :debounce-time="200"
                                            @submit="setProject"
                                    >
                                        <template #result="{ result, props }">
                                            <li v-bind="props">
                                                <p>Name: {{result.project_name}}</p>
                                                <p>Address: {{getFullAddress(result.address)}}</p>
                                                <p>Phone: {{result.phoneNumber ? result.phoneNumber.phone_number : 'N/A'}}</p>
                                                <hr class="uk-divider-icon">
                                            </li>
                                        </template>
                                    </autocomplete>
                                </validated-section>
                            </div>
                            <div class="uk-width-1-5">
                                <a onclick="UIkit.modal.alert('<p>If this is a <strong>single family home</strong> or a <strong>multi-unit single building</strong>, please enter the address of your rental building.</p><p>If this is for a <strong>complex of buildings and units</strong>, please enter the address of your rental office.</p>');"
                                   class="uk-dark uk-light use-hand-cursor theme-primary-bg-color hint-button"
                                >?</a>
                            </div>
                        </div>



                    </div>

                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 ">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Address Line 1</small></p>
                        <validated-section :errors="errors" field="project_address.line_1">
                            <autocompleted-address-form
                                    :states="states"
                                    @input="propertyAddress.line_1 = $event"
                                    @updated="propertyAddress = $event"
                                    ref="propertyAddressSearch"
                                    :counties="counties"></autocompleted-address-form>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Address Line 2</small></p>
                        <TextInput
                                v-model="propertyAddress.line_2"
                                :name="lineTwoLabel"
                                :placeholder="lineTwoLabel"
                        />
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property City</small></p>
                        <validated-section :errors="errors" field="project_address.city">
                            <TextInput
                                    v-model="propertyAddress.city"
                                    name="City"
                                    placeholder="City"
                            />
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property State</small></p>
                        <validated-section :errors="errors" field="project_address.state_id">
                            <select v-model="propertyAddress.state_id" class="uk-width-1-1 state-select uk-form-select uk-form-large">
                                <option v-for="item in states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                            </select>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property ZIP</small></p>
                        <validated-section :errors="errors" field="project_address.zip">
                            <TextInput
                                    v-model="propertyAddress.zip"
                                    name="Zip"
                                    placeholder="Zip"
                            />
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property County</small></p>
                        <validated-section :errors="errors" field="project_address.county_id">
                            <select v-model="propertyAddress.county_id" class="uk-width-1-1 uk-form-select uk-form-large">
                                <option v-for="county in countiesForState" :value="county.id">{{ county.county_name }}</option>
                            </select>
                        </validated-section>

                    </div>
                </div>

                <div class="uk-grid">
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <h2>
                            Property Owner
                            <span class="uk-text-smaller">AS REPORTED ON W9 & TAX RETURN</span>
                        </h2>
                    </div>
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company Name as it appears on Owner's W-9</small></p>
                        <validated-section :errors="errors" field="po_organization.organization_name">
                            <TextInput
                                    v-model="propertyOwnerOrganization.organization_name"
                                    name="Property Owner Company Name"
                                    placeholder="Property Owner Company Name"
                            />
                        </validated-section>
                    </div>

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company Phone Number</small></p>
                        <validated-section :errors="errors" field="po_organization.phone">
                            <phone-number-input
                                    :disabled="propertyOwnerOrganization.organization_id"
                                    name="po_organization.phone"
                                    v-model="propertyOwnerOrganization.phone"
                                    @onValidated="$emit('phoneUpdated', $event)"
                            ></phone-number-input>
                        </validated-section>
                    </div>

                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 ">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company Address as it appears on Owner's W-9</small></p>
                        <validated-section :errors="errors" field="po_organization.address.line_1">
                            <TextInput
                                    v-model="propertyOwnerOrganization.address.line_1"
                                    :disabled="propertyOwnerOrganization.organization_id"
                                    v-if="propertyOwnerOrganization.organization_id"
                                    name="PO Last Name"
                                    placeholder="PO Last Name"
                            />
                            <autocompleted-address-form
                                    :states="states"
                                    v-else
                                    ref="propertyOwnerAddressSearch"
                                    @input="propertyOwnerOrganization.address.line_1 = $event"
                                    @updated="propertyOwnerOrganization.address = $event"
                                    :counties="counties"></autocompleted-address-form>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company Address Line 2</small></p>
                        <TextInput
                                v-model="propertyOwnerOrganization.address.line_2"
                                :disabled="propertyOwnerOrganization.organization_id"
                                :name="lineTwoLabel"
                                :placeholder="lineTwoLabel"
                        />
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company City</small></p>
                        <validated-section :errors="errors" field="po_organization.address.city">
                            <TextInput
                                    v-model="propertyOwnerOrganization.address.city"
                                    :disabled="propertyOwnerOrganization.organization_id"
                                    name="City"
                                    placeholder="City"
                            />
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company State</small></p>
                        <validated-section :errors="errors" field="po_organization.address.state_id">
                            <select v-model="propertyOwnerOrganization.address.state_id"
                                    :disabled="propertyOwnerOrganization.organization_id"
                                    class="uk-width-1-1 state-select uk-form-select uk-form-large">
                                <option v-for="item in states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                            </select>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Owner Company ZIP</small></p>
                        <validated-section :errors="errors" field="po_organization.address.zip">
                            <TextInput
                                    v-model="propertyOwnerOrganization.address.zip"
                                    :disabled="propertyOwnerOrganization.organization_id"
                                    name="Zip"
                                    placeholder="Zip"
                            />
                        </validated-section>
                    </div>



                </div>

                <div class="uk-grid" >
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <h2>Property Manager</h2>
                        <p>This Company's Name and Contacts will be listed in the tenant's search results.</p>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-top">
                    <span class="uk-float-left uk-margin-left">
                        <label for="same-manager">
                            <input id="same-manager" type="checkbox" v-model="sameManagerOwner">
                            &nbsp; The Property Manager Is The Same As The Property Owner
                        </label>
                    </span>
                    </div>
                </div>

                <div v-show="!sameManagerOwner" class="uk-grid">

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company Name</small></p>
                        <validated-section :errors="errors" field="pm_organization.organization_name">
                            <TextInput
                                    v-model="propertyManagerOrganization.organization_name"
                                    name="Property Manager Company Name"
                                    placeholder="Property Manager Company Name"
                            />
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company Phone Number</small></p>
                        <validated-section :errors="errors" field="pm_organization.phone">
                            <phone-number-input
                                    name="Property Manager Phone"
                                    v-model="propertyManagerOrganization.phone"
                                    :disabled="propertyManagerOrganization.organization_id"
                                    :allowValidation="true"
                                    @onValidated="$emit('phoneUpdated', $event)"
                            ></phone-number-input>
                        </validated-section>
                    </div>

                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 ">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company Address Line 1</small></p>
                        <validated-section :errors="errors" field="pm_organization.address.line_1">
                            <autocompleted-address-form
                                    :states="states"
                                    ref="propertyManagerAddressSearch"
                                    :disabled="propertyManagerOrganization.organization_id"
                                    @input="propertyManagerOrganization.address.line_1 = $event"
                                    @updated="propertyManagerOrganization.address = $event"
                                    :counties="counties"></autocompleted-address-form>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company Address Line 2</small></p>
                        <TextInput
                                v-model="propertyManagerOrganization.address.line_2"
                                :name="lineTwoLabel"
                                :placeholder="lineTwoLabel"
                        />
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company City</small></p>
                        <validated-section :errors="errors" field="pm_organization.address.city">
                            <TextInput
                                    v-model="propertyManagerOrganization.address.city"
                                    :disabled="propertyManagerOrganization.organization_id"
                                    name="City"
                                    placeholder="City"
                            />
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company State</small></p>
                        <validated-section :errors="errors" field="pm_organization.address.state_id">
                            <select v-model="propertyManagerOrganization.address.state_id"
                                    :disabled="propertyManagerOrganization.organization_id"
                                    class="uk-width-1-1 state-select uk-form-select uk-form-large" required>
                                <option v-for="item in states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                            </select>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                        <p class="uk-margin-bottom-remove"><small>&nbsp;Property Manager Company ZIP</small></p>
                        <validated-section :errors="errors" field="pm_organization.address.zip">
                            <TextInput
                                    v-model="propertyManagerOrganization.address.zip"
                                    :disabled="propertyManagerOrganization.organization_id"
                                    name="Zip"
                                    placeholder="Zip"
                            />
                        </validated-section>
                    </div>
                </div>


            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import AutocompletedAddressForm from "../../../../dashboard/components/Common/AutocompletedAddressForm";
    import ValidatedSection from "../../../../dashboard/components/Common/ValidatedSection";
    import Autocomplete from "@trevoreyre/autocomplete-vue";
    import {mapState} from "vuex";
    import $ from "jquery";

    export default {
        name: "PropertyOwnerManagerInformation",
        components: {AutocompletedAddressForm, ValidatedSection, Autocomplete },
        props: {
            showInitValue: {
                required: false,
                default: true,
            }
        },
        data() {
            return {
                errors: {},
                //
                roleId: 100001,

                // roleId: 100000,
                sameManagerOwner: false,
                propertyOwnerOrganization: {
                    organization_id: null,
                    organization_name: '',
                    address: {
                        line_1: null,
                        line_2: null,
                        city: null,
                        state_id: null,
                        county_id: null,
                        zip: null,
                    },
                    phone: null,
                    tax_id_number: null,
                    payment_type: null,
                    masked_account_number: null,
                    masked_routing_number: null,
                    masked_tax_id_number: null,
                },
                propertyOwnerPerson: {
                    role_id: 100000,
                    person_id: null,
                    first_name: '',
                    last_name: '',
                },
                propertyManagerOrganization: {
                    organization_id: null,
                    organization_name: '',
                    address: {
                        line_1: null,
                        line_2: null,
                        city: null,
                        state_id: null,
                        county_id: null,
                        zip: null,
                    },
                    phone: null,
                },
                propertyManagerPerson: {
                    role_id: 100001,
                    person_id: null,
                    first_name: '',
                    last_name: '',

                },
                propertyId: null,
                propertyName: '',
                propertyAddress: {},
                //
            }
        },
        computed: {
            roleSelected() {
                let result = this.roles.find(item => item.id === this.roleId)
                return result ? result: {}
            },

            roleListProjectUser() {
                return this.roles.filter(item => item.role_name !== 'Property Administrator')
            },

            countiesForState() {
                if(!this.propertyAddress.state_id) return [];

                return _.filter(this.counties, county => county.state_id === this.propertyAddress.state_id);
            },

            pmRoleId() {
                for(var i in this.roles) {
                    if(this.roles[i].role_name === 'Property Manager') {
                        return this.roles[i].id;
                    }
                }
            },
            poRoleId() {
                for(var i in this.roles) {
                    if(this.roles[i].role_name === 'Property Owner') {
                        return this.roles[i].id;
                    }
                }
            },
            ...mapState('App', {
                permissions: state => state.permissions,
            }),
            ...mapState('Application', {
                assets: 'assets',
                application: state => state.application,
                applicant: state => state.applicant,
                renterOwner: state => state.renterOwner,
                renterManager: state => state.renterManager,
                ownerOrganization: state => state.ownerOrganization,
                managerOrganization: state => state.managerOrganization,
                program: state => state.application.program,
                documents: state => state.documents,
                states: state => state.assets.states,
                counties: state => state.assets.counties,
                project: state => state.project,
            }),
            ...mapState('Landlord', {
                roles: state => state.roles,
                confirmation: state => state.confirmation,
            }),
        },
        watch: {
            sameManagerOwner(newValue) {
                if(newValue) {
                    // Set the role to PO since it doesn't matter and this will
                    // keep data organized.
                    this.roleId = this.poRoleId;

                }
            },
            project(newValue) {
                if(newValue) {
                    this.propertyAddress = this.project.address ? this.project.address : {};
                    this.propertyName = this.project.project_name;
                    this.propertyId = this.project.id;
                    if (this.$refs.propertyAutocomplete)
                    {
                        this.$refs.propertyAutocomplete.value = this.propertyName;
                    }
                    if (this.$refs.propertyAddressSearch && newValue.address)
                    {
                        this.$refs.propertyAddressSearch.setLine1(newValue.address.line_1);
                    }
                }
            },
        },
        async mounted() {

            $(".form-autocomplete .autocomplete-input").attr('autocomplete', 'chrome-off');
            window.setTimeout(async () => {
                await this.initData();
            }, 3500);
        },
        methods: {
            reset() {
                this.roleId = ''
                this.sameManagerOwner = false
                this.propertyOwnerOrganization = {
                    organization_name: '',
                    address: {},
                    phone: null,
                    tax_id_number: null,
                    tax_id_number_confirmation: null,
                }
                this.propertyOwnerPerson = {
                    role_id: 100000,
                    first_name: '',
                    last_name: '',

                }
                this.propertyManagerOrganization = {
                    organization_name: '',
                    address: {},
                    phone: null,
                    tax_id_number: null,
                }
                this.propertyManagerPerson = {
                    role_id: 100001,
                    first_name: '',
                    last_name: '',
                }
                this.propertyName = ''
                this.propertyAddress = {}
                if(this.$refs.propertyAutocomplete) {
                    this.$refs.propertyAutocomplete.value = ''
                }
                if(this.$refs.propertyManagerAddressSearch) {
                    this.$refs.propertyManagerAddressSearch.value = '';
                }
                if(this.$refs.propertyAddressSearch) {
                    this.$refs.propertyAddressSearch.value = '';
                }
                if(this.$refs.propertyOwnerAddressSearch) {
                    this.$refs.propertyManagerAddressSearch.value = '';
                }
                if(this.$refs.pmCompanyAutocomplete) {
                    this.$refs.pmCompanyAutocomplete.value = ''
                }
                if(this.$refs.poCompanyAutocomplete) {
                    this.$refs.poCompanyAutocomplete.value = ''
                }
            },

            getFullAddress(address)
            {
                if (address) {
                    let addressParts = [address.line_1];
                    if(address.line_2) {
                        addressParts.push(address.line_2);
                    }
                    addressParts.push(address.city);
                    addressParts.push(address.state);
                    addressParts.push(address.zip)
                    return addressParts.join(', ');
                }
                return 'N/A'
            },

            async initData() {
                await this.$store.dispatch('App/getUser');
                let r = await axios.get('/api/projects/create');
                this.$store.commit('Project/SET_COUNTIES', this.counties);
                this.$store.commit('Project/SET_STATES', this.states);
                this.$store.commit('Project/SET_LANDLORD_TERMS', r.data.landlordTerms);
                this.$store.commit('Project/SET_ALTERNATIVE_FUNDING_PROGRAMS', r.data.alternativeFundingPrograms);
                this.$store.commit('Project/SET_ROLES', r.data.roles);

                this.propertyOwnerPerson.role_id = this.poRoleId;
                this.propertyManagerPerson.role_id = this.pmRoleId;

                // Set existing property details
                if(this.project && this.showInitValue) {
                    this.propertyAddress = this.project.address || {};
                    this.propertyName = this.project.project_name;
                    this.propertyId = this.project.id;
                    if(this.$refs.propertyAutocomplete) {
                      this.$refs.propertyAutocomplete.value = this.propertyName;
                    }
                    if(this.project.address && this.$refs.propertyAddressSearch) {
                        this.$refs.propertyAddressSearch.setLine1(this.project.address.line_1);
                    }
                }

            },
            async search(query) {

                if(query.length < 3) return [];

                // this.property = null;
                // this.propertyId = null;
                this.propertyName = query;

                // Search People
                let url = '/api/projects/search';

                let r = await axios.get(url+'?query='+query);

                return r.data;
            },

            getProjectValue(result) {
                return result.project_name;
            },

            setProject(result) {
                this.project = {
                    ...result
                };
                this.propertyId = result.id;
                this.propertyName = result.project_name;

                if(result.address) {
                    this.propertyAddress = result.address;
                    this.$refs.propertyAddressSearch.setLine1(result.address.line_1);
                }

                let orgId = null;
                if (this.project && this.project.owner_organization_id)
                    orgId = this.project.owner_organization_id
                // if (this.project && this.project.manager_organization_id)
                //     orgId = this.project.manager_organization_id

                if (orgId)
                    this.$store.dispatch('Project/fetchOrgDocument', orgId)
            },

            async searchPoOrg(query) {

                if(query.length < 3) return [];
                // Search People
                let url = '/api/projects/search-org';

                let r = await axios.get(url+'?query='+query);

                return r.data;
            },

            async onPoBlur() {
                let name = this.$refs.poCompanyAutocomplete.value;
                if(this.propertyOwnerOrganization.organization_id) {
                    if(name === '') {
                        this.$refs.poCompanyAutocomplete.value = this.propertyOwnerOrganization.organization_name;
                    } else if (name !== this.propertyOwnerOrganization.organization_name) {
                        let { isConfirmed, isDenied} = await this.$swal({
                            title: 'Are you sure?',
                            text: `Are you sure you would like to change the property owner company to "${name}" ?`,
                            icon: 'warning',
                            showDenyButton: true,
                            confirmButtonText: 'Yes, I Am Sure',
                            denyButtonText: 'No, Cancel',
                            imageClass: 'alert-image'
                        })

                        if(isConfirmed) {
                            this.propertyOwnerOrganization.organization_id = null;
                            this.propertyOwnerOrganization.organization_name = name;
                            this.propertyOwnerOrganization.address = {}
                            this.propertyOwnerOrganization.phone = '';
                            if(this.$refs.propertyOwnerAddressSearch) {
                                this.$refs.propertyOwnerAddressSearch.setLine1('');
                            }
                        }else {
                            this.$refs.poCompanyAutocomplete.value = this.propertyOwnerOrganization.organization_name;
                        }
                    }else {
                        this.propertyOwnerOrganization.organization_name = name;
                    }
                }else {
                    this.propertyOwnerOrganization.organization_name = name;
                }

            },

            getOrgValue(result) {
                return result.organization_name;
            },

            setPoOrganization(result) {
                if (result)
                {
                    this.propertyOwnerOrganization.organization_id = result.id
                    this.propertyOwnerOrganization.masked_tax_id_number = result.masked_tax_id_number
                    this.propertyOwnerOrganization.masked_account_number = result.masked_account_number
                    this.propertyOwnerOrganization.masked_routing_number = result.masked_routing_number
                    this.propertyOwnerOrganization.bank_account_type = result.bank_account_type
                    this.propertyOwnerOrganization.payment_type = result.payment_type
                    this.propertyOwnerPerson.person_id = result.person_id;
                    this.propertyOwnerPerson.first_name = result.first_name;
                    this.propertyOwnerPerson.last_name = result.last_name;
                    this.propertyOwnerPerson.role_id = 100000;

                    if (result.address)
                    {
                        this.propertyOwnerOrganization.address.line_1 = result.address.line_1
                        this.$refs.propertyOwnerAddressSearch.setLine1(result.address.line_1);
                        this.propertyOwnerOrganization.address.line_2 = result.address.line_2
                        this.propertyOwnerOrganization.address.city = result.address.city
                        this.propertyOwnerOrganization.address.state_id = result.address.state_id
                        this.propertyOwnerOrganization.address.zip = result.address.zip
                    }

                    this.$store.commit('Project/SET_OWNER_ORGANIZATION', this.propertyOwnerOrganization);

                    if (result.phone)
                    {
                        this.propertyOwnerOrganization.phone = result.phone.number
                    }
                }
            },

            async searchPmOrg(query) {
                // this.propertyManagerOrganization.organization_name = query
                // this.propertyManagerOrganization.organization_id = null;
                if(query.length < 3) return [];
                // Search People
                let url = '/api/projects/search-org';

                let r = await axios.get(url+'?query='+query);

                return r.data;
            },
            async onPmBlur() {
                let name = this.$refs.pmCompanyAutocomplete.value;
                if(this.propertyManagerOrganization.organization_id) {
                    if(name === '') {
                        this.$refs.pmCompanyAutocomplete.value = this.propertyManagerOrganization.organization_name;
                    } else if (name === this.propertyManagerOrganization.organization_name) {
                        let { isConfirmed, isDenied} = await this.$swal({
                            title: 'Are you sure?',
                            text: `Are you sure you would like to change the property manager company to "${name}" ?`,
                            icon: 'warning',
                            showDenyButton: true,
                            confirmButtonText: 'Yes, I Am Sure',
                            denyButtonText: 'No, Cancel',
                            imageClass: 'alert-image'
                        })

                        if(isConfirmed) {
                            this.propertyManagerOrganization.organization_id = null;
                            this.propertyManagerOrganization.organization_name = name;
                            this.propertyManagerOrganization.address = {}
                            this.propertyManagerOrganization.phone = '';
                            if(this.$refs.propertyManagerAddressSearch) {
                                this.$refs.propertyManagerAddressSearch.setLine1('');
                            }
                        }else {
                            this.$refs.pmCompanyAutocomplete.value = this.propertyManagerOrganization.organization_name;
                        }
                    }else {
                        this.propertyManagerOrganization.organization_name = name;
                    }
                }else {
                    this.propertyManagerOrganization.organization_name = name;
                }
            },

            setPmOrganization(result) {
                if (result)
                {
                    this.propertyManagerOrganization.organization_id = result.id
                    this.propertyManagerPerson.person_id = result.person_id;
                    this.propertyManagerPerson.first_name = result.first_name;
                    this.propertyManagerPerson.last_name = result.last_name;
                    this.propertyManagerPerson.role_id = 100001;
                    if (result.address)
                    {
                        this.propertyManagerOrganization.address.line_1 = result.address.line_1
                        this.$refs.propertyManagerAddressSearch.setLine1(result.address.line_1);
                        this.propertyManagerOrganization.address.line_2 = result.address.line_2
                        this.propertyManagerOrganization.address.city = result.address.city
                        this.propertyManagerOrganization.address.state_id = result.address.state_id
                        this.propertyManagerOrganization.address.zip = result.address.zip
                    }

                    if (result.phone)
                    {
                        this.propertyManagerOrganization.phone = result.phone.number
                    }
                }
            },


            async validateStep() {
                let stepValid = false
                this.errors = {};

                if(!this.permissions.processor && this.roleId == '') {
                    this.errors['roleId'] = ['You must enter a role.'];
                    stepValid = false;
                }

                if(!this.propertyOwnerOrganization.organization_id) {

                }


                if(_.size(this.errors) > 0) return false;

                stepValid = await this.submitForm()
                // await this.$refs.financialForm.validate().then(async (isValid) => {
                //   if (isValid) {
                //   }
                // })
                return stepValid
            },

            async submitForm() {
                let payload = {
                    confirmation_id: this.confirmation.id,
                    role_id: this.roleId,
                    same_manager_owner: this.sameManagerOwner,
                    po_organization: this.propertyOwnerOrganization,
                    po_person: this.propertyOwnerPerson,
                    pm_organization: this.sameManagerOwner ? this.propertyOwnerOrganization : this.propertyManagerOrganization,
                    pm_person: this.sameManagerOwner ? this.propertyOwnerPerson : this.propertyManagerPerson,
                    project_name: this.propertyName,
                    project_address: this.propertyAddress,
                    project_id: this.propertyId,
                }

                try {
                    let res = await this.$store.dispatch('Landlord/setOwnerManagerInformation', payload);
                    this.setProject(res.project)
                    this.$emit('done', res)
                    this.$emit('loading', false);
                    return true;
                }catch(err) {
                    this.errors = err.response.data.errors;
                    this.$refs.financialForm.setErrors(err.response.data.errors);
                    this.$emit('error', err)
                    this.$emit('loading', false)
                    return false;
                }
            }
        }
    }
</script>
